import { List } from '@jouzen/ecom-components/v3/List';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

import type { RichTextProps } from '@/app/components/RichText';
import RichText from '@/app/components/RichText';

export interface PDPTechSpecsFeatureData {
  readonly copy: RichTextProps;
  readonly Icon: SVGIconComponent;
  readonly title: MessageKey;
}

const PDPTechSpecsFeature = ({
  copy,
  Icon,
  title,
}: PDPTechSpecsFeatureData) => {
  const t = useTranslations();

  return (
    <>
      <div className="flex gap-x-3">
        <Icon height={24} width={24} />
        <Typography className="mb-3" color="inherit" Element="h3" weight="bold">
          {t(title)}
        </Typography>
      </div>
      <List
        className="ml-9 flex flex-col gap-y-2"
        color="inherit"
        unstyled
        variant="eyebrow-small"
      >
        <RichText {...copy} />
      </List>
    </>
  );
};

export default PDPTechSpecsFeature;
